import { useNotification } from "@/shared/feedback/notification";
import { useTranslations } from "use-intl";
import { UploadChangeParam } from "antd/es/upload";
import { UploadFile } from "antd/lib";
import { UploadResponseFile } from "@/shared/form/upload/model/types";

export function useErrorHandler() {
  const notify = useNotification();
  const t = useTranslations("Common");

  return (info: UploadChangeParam<UploadFile<UploadResponseFile>>) => {
    if (!info.file.error) {
      return;
    }

    if (
      info.file.response !== undefined &&
      "localizedMessage" in info.file.response
    ) {
      notify?.error({
        message: info.file.response?.localizedMessage,
      });

      return;
    }

    if (info.file.error.status === 413) {
      notify?.error({
        message: t("FILE_TOO_LARGE_ERROR_MESSAGE", {
          size: "50",
        }),
      });
    } else {
      notify?.error({
        message: info.file.error.message ?? t("UNKNOWN_ERROR"),
        description: info.file.error.stack,
      });
    }
  };
}
